import { useState } from "react";
import QualitySummary from "./QualityReport/QualitySummary";
import QualityDetail from "./QualityReport/QualityDetail";

// QualityReport is now a thin parent that owns the Report Type selection and renders
// the two report variants. Both children stay mounted (display is toggled) so each
// report keeps its own filter state when switching between them. The Report Type radio
// itself lives inside each child's filter card; its value/onChange are wired here via
// the reportType / setReportType props.
const QualityReport = (props) => {

    const [reportType, setReportType] = useState("summary");

    return (
        <>
            <div style={{ display: reportType === "summary" ? "block" : "none" }}>
                <QualitySummary
                    role={props.role}
                    countryListOptionsViaParent={props.countryListOptionsViaParent}
                    publisherListOptionsViaParent={props.publisherListOptionsViaParent}
                    reportType={reportType}
                    setReportType={setReportType}
                />
            </div>

            <div style={{ display: reportType === "detailed" ? "block" : "none" }}>
                <QualityDetail
                    role={props.role}
                    countryListOptionsViaParent={props.countryListOptionsViaParent}
                    publisherListOptionsViaParent={props.publisherListOptionsViaParent}
                    reportType={reportType}
                    setReportType={setReportType}
                />
            </div>
        </>
    );
};

export default QualityReport;
